import { render, staticRenderFns } from "./ItemModifiedWarning.vue?vue&type=template&id=aa59a5ca"
import script from "./ItemModifiedWarning.vue?vue&type=script&lang=js"
export * from "./ItemModifiedWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports